import React from 'react';
import { useSelector } from 'react-redux';
import { defineAbility, type AbilityBuilder, type AnyAbility } from '@casl/ability';
import { createContextualCan } from '@casl/react';
import { useDeepCompareEffect } from '@fuse/hooks';

import { selectUser } from 'app/store/userSlice';
import { getAclProviderConfig } from 'app/main/configs';

export const AuthorizerContext = React.createContext<any>({});
export const Can = createContextualCan(AuthorizerContext.Consumer);

function AclProvider({ children }: { children: React.ReactNode }) {
	const user = useSelector(selectUser);

	const [userAbility, setUserAbility] = React.useState<AnyAbility>();

	useDeepCompareEffect(() => {
		if (user.permissions) {
			setUserAbility(
				defineAbility((can: AbilityBuilder<AnyAbility>['can']) => {
					const actions = Object.keys(user.permissions);
					actions.forEach(action => {
						const resources = user.permissions[action];
						resources.forEach(resource => can(action, resource?.replaceAll('-', '_')));

						getAclProviderConfig({ can, userData: user.data });
					});
				})
			);
		}
	}, [user.data, user.permissions]);

	return <AuthorizerContext.Provider value={userAbility}>{children}</AuthorizerContext.Provider>;
}

export default AclProvider;
